import angular from 'angular';

/**
 * @ngdoc overview
 * @name superuserModule.clientsServices
 * @description
 * # superuserModule.clientsServices
 * Module for managing the services of: clients. For $http requests, API calls.
 */
const clientsServices = angular.module('superuserModule.clientsServices', []);

/**
 * @ngdoc interface
 * @name superuserModule.clientsServices.interface:Client
 * @description
 * Service for handling Clients.
 */
clientsServices.factory('Client', ['$state', 'ClientAPI', 'AppsoupAPI', ($state, ClientAPI, AppsoupAPI) => {
    'use strict';

    return {
        getList: (params) => {
            return ClientAPI.getClients(AppsoupAPI.getTableParams(params))
                .then((response) => {
                    return response.data.clients;
                });
        },
        getSelectList: () => {
            return ClientAPI.getSelectClients();
        },
        get: (clientId) => {
            return ClientAPI.getClient(clientId);
        },
        save: (client, editMode, admin, place) => {
            if (angular.isDefined(admin) && (angular.isDefinedNotNull(admin.role_id) || angular.isDefinedNotEmpty(admin.name) || angular.isDefinedNotEmpty(admin.email))) {
                angular.extend(client, {user: admin});
            } else {
                client.user = {};
            }
            if (angular.isDefined(place)) {
                angular.extend(client, {place: place});
            }

            return editMode ? ClientAPI.editClient(client) : ClientAPI.createClient(client);
        },
        remove: (clientId) => {
            return ClientAPI.removeClient(clientId);
        },
        getPlaces: (params) => {
            return ClientAPI.getClientPlaces(params);
        },
        prepareClientPermissions: (places, applications) => {
            const permissions = AppsoupAPI.preparePlacesTree(places);
            angular.forEach(applications, (value, key) => {
                if (value.m === 0) {
                    applications.splice(key, 1);
                }
            });
            permissions.app = applications;

            return permissions;
        },
        convertClientPermissions: (permissions) => {
            return AppsoupAPI.convertPlacesTree(permissions);
        }
    };
}]);

/**
 * @ngdoc interface
 * @name clientsServices.interface:ClientAPI
 *
 * Service for handling API connections for: Clients.
 */
clientsServices.service('ClientAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/client/`;

    this.getClients = (params) => {
        return $http.get(API_URL, {params: params});
    };

    this.getSelectClients = () => {
        return $http.get(`${API_URL}select-list`);
    };

    this.getClient = (clientId) => {
        return $http.get(`${API_URL}${clientId}`);
    };

    this.createClient = (client) => {
        return $http.post(API_URL, client);
    };

    this.editClient = (client) => {
        return $http.put(`${API_URL}${client.id}`, client);
    };

    this.removeClient = (clientId) => {
        return $http.delete(`${API_URL}${clientId}`);
    };

    this.getClientPlaces = (params) => {
        return $http.get(`${API_URL}place-permission`, {params: params});
    };
}]);

export default clientsServices;
